import { render } from "./sentry.vue?vue&type=template&id=97ccd786"
import script from "./sentry.vue?vue&type=script&lang=js"
export * from "./sentry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__